import { type BoundaryGroup } from '~/boundary/boundary.types';
import type { DemographicsDataProvider } from '~/store/demographics/demographics.types';

export const checkIfBoundaryGroupIsWMSGenerated = (boundaryGroup: BoundaryGroup) => {
  return (boundaryGroup?.wms.territoriesCount ?? 0) > 0;
};

export const checkIfBoundaryGroupIsMOTGenerated = (boundaryGroup: BoundaryGroup) => {
  return (boundaryGroup?.mot.territoriesCount ?? 0) > 0;
};

export const getCheckIsBoundaryGroupFromProvider = (_provider: DemographicsDataProvider) => (
  boundaryGroup: BoundaryGroup,
): boolean => {
  // TODO: will be updated when BE adds a provider field/flag
  return boundaryGroup.codename?.startsWith('ags') ||
      /^h\d/.test(boundaryGroup.codename ?? '');
};
